const devEnvironment = {
  environment: "development",
  instrumentationKey: "35405de8-c323-42cf-904c-85353e725b47",
  apiUrl: "https://devapi.attelas.ai",
  auth: {
    domain: "auth-dev.attelas.ai",
    clientId: "MIbqfrL4YjvevoGMDW4WAToZ1gNO01vv",
    audience: "https://devapi.attelas.ai",
  },
  webAppUrl: "https://app-dev.attelas.ai",
};
const prodEnvironment = {
  environment: "production",
  instrumentationKey: "7d74d6c9-1da1-4fa2-9f8f-98294635fe50",
  apiUrl: "https://api.attelas.ai",
  auth: {
    domain: "auth.attelas.ai",
    clientId: "OGp1eB7CaNRcsG2UBXSd74uYfhR6rGjg",
    audience: "https://api.attelas.ai",
  },
  webAppUrl: "https://app.attelas.ai",
};

export const environment =
  window.location.origin.includes("attelasstorageoutlook.z33") ||
  window.location.origin.includes("o365addin.attelas.ai")
    ? prodEnvironment
    : devEnvironment;
